(function initThankYouPageRenderer() {
  const CLOUDINARY_BASE = 'https://res.cloudinary.com/da9yd4bgx/image/fetch';
  const PUZZLE_TRANSFORM = 'a_0,c_fill,w_480,g_object/t_puzzle-v1';
  const CANVAS_TRANSFORM = 't_canvas-mockup-v1';
  const PERSONALIZED_ROW_SELECTOR = '.personalized-suggestions-row';
  const PRODUCT_BOX_SELECTOR = '[data-pf-type=\"ProductBox\"]';

  let thankYouOfferRendered = false;

  function buildCloudinaryUrl(transform, submissionImageUrl) {
    if (!submissionImageUrl) {
      return null;
    }

    return `${CLOUDINARY_BASE}/${transform}/w_480/${encodeURIComponent(submissionImageUrl)}`;
  }

  function updateImages(container, imageUrl) {
    if (!container || !imageUrl) {
      return;
    }

    const images = container.querySelectorAll('img');

    images.forEach((img) => {
      img.src = imageUrl;
      img.setAttribute('srcset', imageUrl);
      img.setAttribute('data-src', imageUrl);
      img.setAttribute('data-srcset', imageUrl);
      img.style = '';
    });
  }

  function renderThankYouPageOffer({ submissionImageUrl, dn } = {}) {
    if (thankYouOfferRendered || !submissionImageUrl || typeof waitForElm !== 'function') {
      return;
    }

    const headerEl = document.querySelector('.personalized-product-header');
    if (dn && headerEl) {
      headerEl.innerHTML = `Check Out Some Paw-some Products <br><strong style="font-size: 26px; color: #e46638;"><em style="font-size: 20px">Featuring</em> ${dn}</strong>`;
    }

    const puzzleImageUrl = buildCloudinaryUrl(PUZZLE_TRANSFORM, submissionImageUrl);
    const canvasImageUrl = buildCloudinaryUrl(CANVAS_TRANSFORM, submissionImageUrl);

    waitForElm(PERSONALIZED_ROW_SELECTOR)
      .then((row) => {
        const productBoxes = Array.from(row.querySelectorAll(PRODUCT_BOX_SELECTOR));

        if (!productBoxes.length) {
          return;
        }

        const [puzzleBox, canvasBox] = productBoxes;

        updateImages(puzzleBox, puzzleImageUrl);
        updateImages(canvasBox, canvasImageUrl);

        thankYouOfferRendered = true;
      })
      .catch((error) => {
        console.log('Failed to render thank you page offer', error);
      });
  }

  window.renderThankYouPageOffer = renderThankYouPageOffer;
})();
